import { Record } from "immutable";

const TaskListRecord = Record({
  class: `TaskList`,
  completed_by_id: 0,
  completed_on: null,
  completed_by_email: ``,
  completed_by_name: ``,
  completed_tasks: 0,
  created_by_id: 0,
  created_on: null,
  due_on: null,
  id: 0,
  is_completed: false,
  is_trashed: false,
  original_is_trashed: false,
  name: ``,
  open_tasks: 0,
  position: 0,
  project_id: 0,
  start_on: null,
  trashed_by_id: 0,
  trashed_on: null,
  updated_by_id: 0,
  updated_on: null,
  url_path: ``,
  _pending: false,
});

class TaskList extends TaskListRecord {}

export default TaskList;
